export default __webpack_public_path__ + "assets/863e13.svg";